module.exports = __webpack_public_path__ + "static/media/message-box-icon.d2f4fad0.png";